export const createAccessor = <T extends Record<string, unknown>, TKey extends keyof T = keyof T>(key: TKey) => {
  return (row: T): T[TKey] => row[key];
};
